import { render, staticRenderFns } from "./roleAuthorityConsult.vue?vue&type=template&id=173fb5d2&"
import script from "./roleAuthorityConsult.vue?vue&type=script&lang=js&"
export * from "./roleAuthorityConsult.vue?vue&type=script&lang=js&"
import style0 from "./roleAuthorityConsult.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports